export default "__VITE_ASSET__KBw3oVuT__"